import store from "../store";

export default function authPartner({ next, router }) {
  if (!store.getters.isAuthenticatedPartner) {
    return router.push({ name: "LoginPartner" });
  }

  return next();
}
